export default function interviewAppointment({ to, next, store }) {
  const loanFormState = store.getters['auth/loanFormState']
  const routeName = to.name

  if (loanFormState !== 'choose_loan_type') {
    if ((loanFormState === null || loanFormState === 'null') && routeName !== 'qr-scan') {
      return next({ name: 'qr-scan' })
    } else if (loanFormState === 'qr_scan' && routeName !== 'customer-information') {
      return next({ name: 'customer-information' })
    } else if (loanFormState === 'customer_information' && routeName !== 'required-documents') {
      return next({ name: 'required-documents' })
    } else if (loanFormState === 'required_documents' && routeName !== 'additional-information') {
      return next({ name: 'additional-information' })
    } else if (loanFormState === 'additional_information' && routeName !== 'choose-loan-type') {
      return next({ name: 'choose-loan-type' })
    } else {
      return next()
    }
  }
  return next()
}
